import { render, staticRenderFns } from "./PsychologistCard.vue?vue&type=template&id=29ffb1c2&scoped=true&"
import script from "./PsychologistCard.vue?vue&type=script&lang=ts&"
export * from "./PsychologistCard.vue?vue&type=script&lang=ts&"
import style0 from "./PsychologistCard.vue?vue&type=style&index=0&id=29ffb1c2&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ffb1c2",
  null
  
)

export default component.exports